<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" v-if="backRole('CM_3')" @click="EditMeetingRoom('create')" size="mini">添加会议室
        </el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <!-- <el-table-column prop="deptName" label="所属公司">
      </el-table-column> -->
      <el-table-column prop="address" label="会议室地址" width="120">
      </el-table-column>
      <el-table-column label="会议室预定情况" width="">
        <template slot-scope="scope">
          <div class="no-txt" v-if="scope.row.conferences.length<1">暂无会议安排</div>
          <el-table v-else :data="scope.row.conferences" class="table-in-room">
            <el-table-column prop="name" label="会议名称">
            </el-table-column>
            <el-table-column label="创建人" width="150px">
              <template slot-scope="scope">
                <user-info :userData='scope.row.creator'></user-info>
              </template>
            </el-table-column>
            <el-table-column prop="conferenceTime" label="会议时间">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80px">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="管理员" width="180px" align="center">
        <template slot-scope="scope">
          <user-info :userData='scope.row.admin'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230px">
        <template slot-scope="scope">
          <el-button type="success" v-if="backRole('CM_4')" plain size="mini" @click="CreateMeet(scope.row)">新建会议
          </el-button>
          <el-button plain size="mini" v-if="backRole('CM_3')" @click="EditMeetingRoom(scope.row)">修改</el-button>
          <el-button plain size="mini" v-if="backRole('CM_3')" @click="DeleteMeetingRoom(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加会议室 -->
    <div class="pop-room" v-if="addMeetingRoomStatus">
      <a href="javascript:;" @click="addMeetingRoomStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="所属公司">
              <el-select :disabled="noSelectOrganization" size="small" class="organization-select" v-model="form.depId"
                placeholder="请选择所属公司">
                <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会议室名/位置">
              <el-input size="small" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item label="会议室管理员">
              <!-- <el-col :span="10"> -->
              <user-info style="float:left;width:auto;" v-if="Leader" :userData='Leader'></user-info>
              <el-button @click="addUsers(1)" style="margin-left:10px;" round size="mini" type="primary">选择</el-button>
              <!-- </el-col> -->
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addMeetingRoom()" class="form-btn" type="success">确认{{ type==2?'修改':'添加' }}会议室
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  export default {
    mixins: [Role],
    components: {
      UserInfo,
    },
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
        contactType: state => state.main.contactType,
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        type: 1,

        organizationListData: [],
        noSelectOrganization: false,
        form: {
          depId: "",
          adminId: '',
          address: "",
        },
        editForm: {
          roomId: '',
          adminId: '',
          address: '',
        },
        leaderType: "",
        Leader: "",
        addMeetingRoomStatus: false,

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        // this.noSelectOrganization = false
      }

      // 获取所有会议室
      this.getLists()
    },
    methods: {
      // 选择更换项目/款项负责人
      addUsers(type) {
        this.leaderType = type
        let _sr = []
        switch (type) {
          case 1:
            if (this.Leader) {
              _sr.push(this.Leader)
            }
            break;
        }
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },

      // 修改会议室
      EditMeetingRoom(row) {
        if (row == 'create') {
          this.type = 1
          this.addMeetingRoomStatus = true
          this.form.address = ""
          this.Leader = ""
        } else {
          this.type = 2
          this.addMeetingRoomStatus = true
          this.form.depId = row.deptId
          this.form.address = row.address
          this.Leader = row.admin

          this.editForm.roomId = row.id
        }
      },
      // 新建会议
      CreateMeet(row) {
        // let meeting_data = {
        //   depId: row.deptId,
        //   roomId: row.id
        // }
        // this.$store.commit('set_createMeetingData', meeting_data)
        this.$router.push({
          path: '/Meeting/CreateApproval',
          query: {
            depId: row.deptId,
            roomId: row.id,
          }
        })
      },
      // 删除会议室
      DeleteMeetingRoom(row) {
        if (row.conferences.length > 0) {
          this.$message.error("该会议室已经正常使用，无法删除该会议室")
        }
        this.loading = true
        ajax.post('/conference/room/del', {
          'roomId': row.id
        }, (res) => {
          this.$message.success("删除会议室成功")
          this.getLists()
        })
      },
      // 添加/修改会议室
      addMeetingRoom() {
        if (!this.form.address) {
          this.$message.error("会议室名/位置不能为空")
          return
        }

        let _form = this.form
        let _url = '/conference/room/add'
        if (this.type == 2) {
          _url = '/conference/room/edit'
          this.editForm.address = this.form.address
          _form = this.editForm
        }
        _form.adminId = this.Leader ? this.Leader.id : ""

        ajax.post(_url, _form, (res) => {
          if (this.type == 2) {
            this.$message.success("修改会议室成功")
          } else {
            this.$message.success("添加会议室成功")
          }
          this.addMeetingRoomStatus = false
          this.getLists()
        })
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.post('/conference/room/list', {
          'depId': this.form.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      contactSelectArr() {
        if (this.contactSelectArr.length < 1 || this.contactType) {
          return
        }
        this.selectArr = this.contactSelectArr
        let _p = this.selectArr[0]
        // 如果印章领导发生变化
        if ((!this.Leader || _p.id != this.Leader.id) && this.leaderType == 1) {
          this.Leader = _p
        }
      },
      'form.depId'() {
        this.getLists()
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/meeting/roomlist.vue